'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouter = require('react-router');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _Dropdown = require('react-bootstrap/lib/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _common = require('../../common');

var _utils = require('../../../utils');

var _util = require('../../../utils/util');

var _constants = require('../../../constants');

var _renderUtils = require('../../../lib/mighty-fields/renderUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var BRAND_NAME = _constants.AppConstants.BRAND_NAME,
    CASE_UPDATE_TYPES = _constants.AppConstants.CASE_UPDATE_TYPES,
    CONTACT_TYPES = _constants.AppConstants.CONTACT_TYPES,
    ROUTING = _constants.AppConstants.ROUTING;
var getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;
var CaseUpdateContact = (_dec = (0, _mobxReact.inject)('CaseStore', 'Clients', 'CaseUpdateStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(CaseUpdateContact, _Component);

  function CaseUpdateContact() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CaseUpdateContact);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaseUpdateContact.__proto__ || Object.getPrototypeOf(CaseUpdateContact)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isLoading', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CaseUpdateContact, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      _reactTooltip2.default.rebuild();
    }
  }, {
    key: 'onSelectContact',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(eventKey) {
        var _props, _case, CaseStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, _case = _props._case, CaseStore = _props.CaseStore;
                _context.next = 3;
                return this.isLoading.until(CaseStore.update({ caseId: _case.id, data: { tracking_contact: eventKey } }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSelectContact(_x) {
        return _ref2.apply(this, arguments);
      }

      return onSelectContact;
    }()
  }, {
    key: 'onSelectAdd',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(eventKey) {
        var currentLocation, newPathname;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                currentLocation = _reactRouter.browserHistory.getCurrentLocation(), newPathname = new _utils.CaseUrlBuilder(currentLocation.pathname).change('main', 'contacts').toPathname();


                _reactRouter.browserHistory.push({ pathname: newPathname });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onSelectAdd(_x2) {
        return _ref3.apply(this, arguments);
      }

      return onSelectAdd;
    }()
  }, {
    key: 'onCaseUpdateRequestClick',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _props2, _case, CaseUpdateStore, Clients, updateAction, caseObject;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _props2 = this.props, _case = _props2._case, CaseUpdateStore = _props2.CaseUpdateStore, Clients = _props2.Clients, updateAction = CASE_UPDATE_TYPES.request.key;
                _context3.next = 3;
                return Clients.cases.retrieve(_case.id);

              case 3:
                caseObject = _context3.sent;

                CaseUpdateStore.action = updateAction;
                CaseUpdateStore.caseSearchResults = [caseObject];
                CaseUpdateStore._case = caseObject;
                _reactRouter.browserHistory.push(ROUTING.caseUpdate + '/' + updateAction);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onCaseUpdateRequestClick() {
        return _ref4.apply(this, arguments);
      }

      return onCaseUpdateRequestClick;
    }()
  }, {
    key: 'renderWarningIcon',
    value: function renderWarningIcon() {
      if (this.isNotEditableOnRegistry) {
        return _react2.default.createElement(
          'span',
          { 'data-tip': true, 'data-for': 'registry-migration-error', id: 'icon-registry-migration-warning' },
          _react2.default.createElement(_common.Icon, { type: 'exclamation-triangle' }),
          ' '
        );
      }

      if (this.isRegistryCaseWithoutContactEmail) {
        return _react2.default.createElement(
          'span',
          { 'data-tip': true, 'data-for': 'registry-migration-error', id: 'icon-registry-migration-error' },
          _react2.default.createElement(_common.Icon, { style: { color: 'yellow' }, type: 'exclamation-triangle' }),
          ' '
        );
      }

      return null;
    }
  }, {
    key: 'renderName',
    value: function renderName() {
      var hasValidContactType = this.trackingContact && CONTACT_TYPES[this.trackingContact.contact_type];

      return _react2.default.createElement(
        'div',
        null,
        (0, _renderUtils.renderWarningTooltip)(this.warningMessage, 'registry-migration-error'),
        this.renderWarningIcon(),
        _react2.default.createElement(
          'span',
          null,
          getNameOrDefault(this.trackingContact),
          hasValidContactType && ' - (' + CONTACT_TYPES[this.trackingContact.contact_type].shortDisplay + ')'
        )
      );
    }
  }, {
    key: 'renderDropdown',
    value: function renderDropdown() {
      return _react2.default.createElement(
        _Dropdown2.default,
        { id: 'dropdown-tracking-contact', pullRight: true },
        _react2.default.createElement(
          _Dropdown2.default.Toggle,
          { noCaret: true, bsStyle: 'link', className: 'btn-edit' },
          _react2.default.createElement(_common.Icon, { type: 'pencil' })
        ),
        _react2.default.createElement(
          _Dropdown2.default.Menu,
          { pullRight: true },
          this.dropdownItems.map(function (props) {
            return _react2.default.createElement(_MenuItem2.default, _extends({
              key: props.key
            }, props));
          })
        )
      );
    }
  }, {
    key: 'onDocumentRequestClick',
    value: function onDocumentRequestClick() {
      var _case = this.props._case;

      _reactRouter.browserHistory.push('/case/' + _case.id + '/request-documents');
    }
  }, {
    key: 'renderRequestDropdown',
    value: function renderRequestDropdown() {
      return _react2.default.createElement(
        _Dropdown2.default,
        { id: 'dropdown-request', pullRight: true },
        _react2.default.createElement(
          _Dropdown2.default.Toggle,
          { noCaret: true, bsStyle: 'link', className: 'btn-request' },
          _react2.default.createElement(_common.Icon, { type: 'envelope' }),
          ' ',
          'Make a Request'
        ),
        _react2.default.createElement(
          _Dropdown2.default.Menu,
          { pullRight: true },
          _react2.default.createElement(
            _MenuItem2.default,
            { onClick: this.onDocumentRequestClick },
            'Request Case Documents'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var FunderStore = this.props.FunderStore;


      return _react2.default.createElement(
        'div',
        { className: 'case-update-contact flex-between' },
        _react2.default.createElement(
          'div',
          { className: 'flex-align-center dropdown-arrow right' },
          this.renderName(),
          this.renderDropdown()
        ),
        FunderStore.canUseCommunicationTools && _react2.default.createElement(
          'div',
          { className: 'dropdown-arrow right' },
          this.renderRequestDropdown()
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'contacts',
    get: function get() {
      var _case = this.props._case;


      return (0, _util.getContactsFromCase)(_case);
    }
  }, {
    key: 'trackingContact',
    get: function get() {
      var _case = this.props._case,
          trackingContactId = _case.tracking_contact;


      if (trackingContactId) {
        return (0, _find3.default)(this.contacts, function (contact) {
          return contact.id === trackingContactId;
        });
      }

      return null;
    }
  }, {
    key: 'dropdownItems',
    get: function get() {
      var _this2 = this;

      var _case = this.props._case,
          menuItems = [];


      this.contacts.forEach(function (contact) {
        var type = CONTACT_TYPES[contact.contact_type];

        menuItems.push({
          active: _case.tracking_contact === contact.id,
          children: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              getNameOrDefault(contact)
            ),
            type && _react2.default.createElement(
              'div',
              null,
              type.display
            )
          ),
          eventKey: contact.id,
          key: contact.id,
          onSelect: _this2.onSelectContact
        });
      });

      if (!menuItems.length) {
        menuItems.push({
          children: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
            ' Add Contact(s)'
          ),
          className: 'action',
          key: 'add_contacts',
          onSelect: this.onSelectAdd
        });
      }

      return menuItems;
    }
  }, {
    key: 'isRegistryCaseWithoutContactEmail',
    get: function get() {
      var _case = this.props._case,
          hasContactWithoutEmail = this.trackingContact && !this.trackingContact.email;


      return _case.migrate_to_registry && hasContactWithoutEmail;
    }
  }, {
    key: 'isNotEditableOnRegistry',
    get: function get() {
      var _case = this.props._case;

      return _case.migrate_to_registry && !_case.is_editable_on_registry;
    }
  }, {
    key: 'warningMessage',
    get: function get() {
      if (this.isNotEditableOnRegistry) {
        return 'Changes will not be reflected in the Law Firm Portal as the case info has been locked by the law firm';
      }

      if (this.isRegistryCaseWithoutContactEmail) {
        return 'Add email in order for contact to be added to the ' + BRAND_NAME + ' Law Firm Portal!';
      }

      return null;
    }
  }]);

  return CaseUpdateContact;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  CaseUpdateStore: _propTypes2.default.object,
  Clients: _propTypes2.default.object,
  FunderStore: _propTypes2.default.object
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _utils.SmartBool();
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'trackingContact', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'trackingContact'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCaseUpdateRequestClick', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onCaseUpdateRequestClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'dropdownItems', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'dropdownItems'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = CaseUpdateContact;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(BRAND_NAME, 'BRAND_NAME', '/app/src/components/page-case/main-contacts/CaseUpdateContact.js');
  reactHotLoader.register(CASE_UPDATE_TYPES, 'CASE_UPDATE_TYPES', '/app/src/components/page-case/main-contacts/CaseUpdateContact.js');
  reactHotLoader.register(CONTACT_TYPES, 'CONTACT_TYPES', '/app/src/components/page-case/main-contacts/CaseUpdateContact.js');
  reactHotLoader.register(ROUTING, 'ROUTING', '/app/src/components/page-case/main-contacts/CaseUpdateContact.js');
  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-case/main-contacts/CaseUpdateContact.js');
  reactHotLoader.register(CaseUpdateContact, 'CaseUpdateContact', '/app/src/components/page-case/main-contacts/CaseUpdateContact.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-contacts/CaseUpdateContact.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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